import { Component, OnInit, AfterViewInit, ViewChild, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PershingTranslationService } from '@pershing/pershing-core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'mortgages',
    templateUrl: './mortgages.component.html',
    styleUrls: ['./mortgages.component.css'],
    animations: [
      trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
        state('expanded', style({ height: '*', visibility: 'visible' })),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]),
    ],
})
export class MortgagesComponent implements OnInit, AfterViewInit {

    @Input() mortgagesData: any;
    localmortgagesData: any;
    displayedColumns = ['action','institution','clientAcctNumber','currentBalance'];
    dataSource: MatTableDataSource<Element>;
    @ViewChild('MatPaginator', { static: false }) paginator: MatPaginator;
    @ViewChild('sort', { static: false }) sort: MatSort;
    expandedElement: any;
    expandedId: any;
    panelOpenState: boolean = false;
    constructor(
        private translationService: PershingTranslationService,
        private route: ActivatedRoute
    ) {
      this.dataSource = new MatTableDataSource();
    }

    ngOnInit() {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
        this.localmortgagesData = this.mortgagesData != null ? this.mortgagesData.mortgageDetails : null ;
        this.dataSource = this.localmortgagesData;
        if(this.route.snapshot.queryParams.expandLiabilities == 'M') { 
         // this.expandedId = this.route.snapshot.queryParams.expandID;
          this.panelOpenState =true;
        } else {
         // this.expandedId = 'undefined';
          this.panelOpenState = false;
        }
    }

    ngAfterViewInit(): void {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;    
    }
}
